import { ContentHeader } from 'Components/ContentHeader';
import { OTPFormStepper } from './FormStepper';
import { OTPLoginContextProvider } from 'Context/OTPLoginContext';
import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop, useIsOtpLogin } from 'Hooks';
import { CustomMetaTitle } from 'Components';

export const OTPLogin = () => {
  const isDesktop = useIsDesktop();
  const { isOtp, isAuth } = useIsOtpLogin();

  return (
    <Stack gap={isDesktop ? '64px' : '32px'}>
      <CustomMetaTitle
        disablePrefix
        title={
          Dictionary[DICTIONARY.OTP_Login].metaTitle +
          ' - ' +
          Dictionary[DICTIONARY.OTP_Login].metaTitleStep.stepOne
        }
      />
      <ContentHeader isOtp={isOtp} isAuth={isAuth}>
        <Typography
          variant={'h4'}
          textAlign={'center'}
          whiteSpace={'nowrap'}
          marginBottom={isDesktop ? '50px' : undefined}
          component='h2'
        >
          {Dictionary[DICTIONARY.ContentHeader].subTitle}
        </Typography>
      </ContentHeader>
      <OTPLoginContextProvider>
        <OTPFormStepper />
      </OTPLoginContextProvider>
    </Stack>
  );
};
